import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router'
import { MainService } from 'src/app/services/main.service';
import { HttpClient } from '@angular/common/http';
import { Subscription, from } from 'rxjs'
import { CookieService } from '../../../../node_modules/ngx-cookie-service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { TH } from '../../constants/constants'
import { EN } from '../../constants/constants'


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() subscription: Subscription;
  favNum: any = 0
  isShowMenu = false
  isToggleSearch = false

  language = JSON.parse(localStorage.getItem('language'))
  language_flag = localStorage.getItem('language_flag')

  menuList = []
  submenuList = []


  searchValue = ''
  icon_show = true;

  @ViewChild('search') searchField: ElementRef

  constructor(private router: Router, private _mainService: MainService, private http: HttpClient,
    private cookieService: CookieService) {

    // this.http.get<{ ip: string }>('https://jsonip.com').subscribe(data => {

    // })

    this._mainService.get_FavNum(localStorage.getItem('uuid_')).subscribe(response => {
      this.favNum = response['favNum'];
    })

    this.subscription = _mainService.favNumAnnounce$.subscribe(response => {
      this.favNum = response
    })

  }

  _onHideSearch() {
    if (this.isToggleSearch) {
      this.searchValue = ''
      this.isToggleSearch = false
      this.icon_show = true;
    }
  }

  _onShowSearch() {
    if (!this.isToggleSearch) {
      this.isToggleSearch = true
      this.icon_show = false;
      setTimeout(() => {
        this.searchField.nativeElement.focus()
      }, 300);
    }
  }

  _onToggleMenu() {
    this.isShowMenu = !this.isShowMenu
  }

  hideMenu() {
    this.isShowMenu = false;
  }

  ngOnInit() {
    if (this.language == null) {
      this.language = JSON.parse(JSON.stringify(TH));
    }
    if (this.language_flag == null) {
      this.language_flag = 'th';
    }
    this.setLanguage();
    this.icon_show = true;
  }

  setLanguage() {
    this.menuList = [
      { path: '/home', title: this.language.menu1 },
      { path: '/fund', title: this.language.menu2 },
      { path: '/private-fund', title: this.language.menu3 },
      { path: '/provident-fund', title: this.language.menu4 },
      { path: '/calculate', title: this.language.menu5 },
      { path: '/fund-service-unit', title: this.language.menu6 },
      { path: '/about-us', title: this.language.menu7 },
      { path: '/contact-us', title: this.language.menu8 },
    ]
    this.submenuList = [
      { path: '/compliance-good-governence/option1', title: this.language.fmenu2 },
      { path: '/compliance-index-manager/option1', title: this.language.fmenu4 },
      { path: '/th/News', title: this.language.fmenu8 },
      { path: '/Promotion/promo', title: this.language.fmenu10 },
      { path: '/Faq', title: 'FAQ' },
      { path: '/Calendar', title: this.language.fmenu11 },
      { path: '/Sitemap2', title: this.language.fmenu13 },
      { path: '/job-list', title: this.language.fmenu14 },
    ]
  }

  gotoOneLive() {
    window.open('https://onelive.one-asset.com/Home', '_blank')
  }

  getSearch(event) {
    if (event.keyCode === 13) {
      this.router.navigate(['/SearchInfo', this.searchValue]);
    }
  }

  changelanguage(lang) {
    if (lang === 'en') {
      localStorage.setItem('language', JSON.stringify(EN));
      localStorage.setItem('language_flag', 'en');
      window.location.reload();
    } else if (lang === 'th') {
      localStorage.setItem('language', JSON.stringify(TH));
      localStorage.setItem('language_flag', 'th');
      window.location.reload();
    }
  }

}
